<template>
    <div id="nav-container" class="sign_1_1 bg-cover">
            <a href="#/"><span class="navbuttons navbar">Home</span></a>
            <a href="#/archives"><span class="navbuttons navbar">Archive</span></a>
            <a href="#/gallery"><span class="navbuttons navbar">Gallery</span></a>
            <a href="#/about"><span class="navbuttons navbar">About</span></a>
    </div>
</template>


<script>
export default {
  name: 'pagenav',
}
</script>


<style>
  .sign_1_1 {
    background-image: url('../assets/sign_1.png');
      background-repeat: round;
  }
  #nav-container{
    margin-left: auto;
    margin-right: auto;
    margin-top: 25px;
    padding-left: 10%;
    padding-right: 10%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  a {
    color: inherit;
    text-decoration: none;
  }
  a:hover{
    text-decoration: none;
  }
</style>